import { For, Show } from "solid-js";
import { abilityDef, pieceDef, type AbilityId, type Card, type PieceTypeId, type PlayerId } from "../../core";
import type { GameController } from "../../app/controller";
import { PieceIcon } from "./PieceIcon";

export function Hand(props: { controller: GameController }) {
  const c = props.controller;
  const hand = () => c.store.state.players[c.viewer()].hand;

  const isSelected = (card: Card) => {
    const sel = c.selection();
    return sel != null && "cardId" in sel && sel.cardId === card.id;
  };

  return (
    <div class="hand">
      <Show when={hand().length > 0} fallback={<div class="hand-empty">Hand is empty — you'll draw at the start of your turn.</div>}>
        <For each={hand()}>
          {(card: Card) => (
            <button
              class="card"
              classList={{
                selected: isSelected(card),
                ability: card.kind === "ability",
                discardable: c.mustDiscard(),
              }}
              onClick={() => c.selectCard(card)}
            >
              {card.kind === "piece" ? (
                <PieceFace piece={card.piece} owner={c.viewer()} />
              ) : (
                <AbilityFace ability={card.ability} />
              )}
            </button>
          )}
        </For>
      </Show>

      {/* Resurrection: pick which fallen piece to bring back from the graveyard. */}
      <Show when={c.reviveOptions().length > 0}>
        <div class="revive-picker">
          <span class="revive-label">Bring back:</span>
          <For each={c.reviveOptions()}>
            {(type) => (
              <button class="revive-opt" title={pieceDef(type).name} onClick={() => c.playRevive(type)}>
                <PieceIcon type={type} owner={c.viewer()} />
              </button>
            )}
          </For>
        </div>
      </Show>
    </div>
  );
}

function PieceFace(props: { piece: PieceTypeId; owner: PlayerId }) {
  const def = () => pieceDef(props.piece);
  return (
    <>
      <span class="ccost">{def().cost}</span>
      <span class="cglyph">
        <PieceIcon type={props.piece} owner={props.owner} />
      </span>
      <span class="cname">{def().name}</span>
    </>
  );
}

function AbilityFace(props: { ability: AbilityId }) {
  const def = () => abilityDef(props.ability);
  return (
    <>
      <span class="ccost">{def().cost}</span>
      <span class="cglyph cglyph-ability">{def().glyph}</span>
      <span class="cname">{def().name}</span>
    </>
  );
}
